import React from 'react';
import './Section.css';
import './Skills.css';

const skillGroups = [
  {
    category: 'Languages',
    icon: '{ }',
    skills: ['Python', 'JavaScript', 'Bash', 'HTML5', 'CSS3'],
  },
  {
    category: 'Frameworks & Libraries',
    icon: '⚛',
    skills: ['React', 'Next.js', 'FastAPI', 'Flask', 'Streamlit', 'NumPy', 'Pandas', 'Scikit-learn'],
  },
  {
    category: 'ML / AI',
    icon: '🧠',
    skills: ['XGBoost', 'LightGBM', 'CatBoost', 'Optuna', 'Meta LLaMA', 'MTCNN', 'OpenCV', 'MediaPipe', 'BeautifulSoup', 'Selenium'],
  },
  {
    category: 'Cloud & DevOps',
    icon: '☁',
    skills: ['Google Cloud Platform', 'Docker (basic)', 'Git', 'Linux/Unix', 'Postman'],
  },
  {
    category: 'Tools & Utilities',
    icon: '🔧',
    skills: ['VS Code', 'Jupyter Notebook', 'Figma', 'Ezoic (DNS)', 'Upwork'],
  },
];

export default function Skills() {
  return (
    <section id="skills" className="section">
      <div className="section-inner">
        <div className="section-header">
          <span className="section-num">04.</span>
          <h2 className="section-title">technical skills</h2>
          <div className="section-line" />
        </div>

        <div className="skills-grid">
          {skillGroups.map(group => (
            <div key={group.category} className="skill-group">
              <div className="skill-group-header">
                <span className="skill-icon">{group.icon}</span>
                <h3>{group.category}</h3>
              </div>
              <div className="skill-pills">
                {group.skills.map(s => (
                  <span key={s} className="skill-pill">{s}</span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
